import moment, { Moment } from "moment";

export interface NoticeSummaryDto {
  winnerNoticeId: number;
  isPrimary: boolean;
  title: string | null;
  content: string;
}

export interface NoticeListDto {
  id: number;
  isPrimary: boolean;
  title: string | null;
  content: string;
  images: string[];
  updatedAt: string;
}

export interface NoticeCreateDto {
  isPrimary: boolean;
  targetRewardIds: number[];
  title: string | null;
  content: string;
  images: string[];
}

export interface NoticeModifyDto {
  isPrimary: boolean;
  title: string | null;
  content: string;
  images: string[];
}

export class Notice {
  id: number | null;
  isPrimary: boolean;
  title: string | null;
  content: string;
  images: string[];
  updatedAt?: Moment;

  constructor(dto: NoticeSummaryDto | NoticeListDto) {
    if ("winnerNoticeId" in dto) {
      this.id = dto.winnerNoticeId;
      this.images = [];
    } else {
      this.id = dto.id;
      this.updatedAt = moment(dto.updatedAt);
      this.images = dto.images ?? [];
    }
    this.isPrimary = dto.isPrimary;
    this.title = dto.title;
    this.content = dto.content;
  }
}
